module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_5010.7c756e38.png";